/* Cité Érotik — floating contact widget (reworked, lightweight) */
(function () {
  'use strict';

  class ChatWidget extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-chat-panel]');
      this.toggle = this.querySelector('[data-chat-toggle]');
      this.iconOpen = this.querySelector('[data-chat-icon-open]');
      this.iconClose = this.querySelector('[data-chat-icon-close]');
      this.open = false;
      if (!this.panel || !this.toggle) return;

      this.toggle.addEventListener('click', () => this.setOpen(!this.open));
      document.addEventListener('click', (e) => { if (!this.contains(e.target) && this.open) this.setOpen(false); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.setOpen(false); });
    }

    setOpen(open) {
      this.open = open;
      this.panel.classList.toggle('scale-0', !open);
      this.panel.classList.toggle('opacity-0', !open);
      this.panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (this.iconOpen) this.iconOpen.classList.toggle('hidden', open);
      if (this.iconClose) this.iconClose.classList.toggle('hidden', !open);
    }
  }
  if (!customElements.get('chat-widget')) customElements.define('chat-widget', ChatWidget);
})();
